import { WSFilterDateRangeValue } from "@wingspanhq/fe-component-library";
import { UrlQueryFilter } from "../../../../../shared/hooks/useUrlQuery";

export enum WorkLogPayerTabFilterStatus {
  ToApprove = "to-approve",
  InProgress = "in-progress",
  Approved = "approved",
  Rejected = "rejected"
}

export interface Filter extends UrlQueryFilter {
  payeeId?: string;
  assignmentId?: string;
  dateRange?: WSFilterDateRangeValue;
  status?: WorkLogPayerTabFilterStatus;
}

export type SortField = "updatedAt";
